/** Writing direction of a text: left-to-right or right-to-left. */
export type TextDirection = "ltr" | "rtl";

const RTL_LANGUAGE_PREFIXES = ["ar", "fa", "he", "ur"] as const;

function primaryLanguageTag(localeTag: string): string {
  const normalized = localeTag.trim().toLowerCase();
  const [primary] = normalized.split(/[-_]/);
  return primary ?? normalized;
}

/**
 * Returns the writing direction for a BCP 47 or POSIX locale tag based on its primary language.
 * Arabic, Persian, Hebrew and Urdu are right-to-left; every other language is left-to-right.
 */
export function textDirectionForLocale(localeTag: string): TextDirection {
  const primary = primaryLanguageTag(localeTag);
  return RTL_LANGUAGE_PREFIXES.includes(primary as (typeof RTL_LANGUAGE_PREFIXES)[number])
    ? "rtl"
    : "ltr";
}
